function toArray<T extends object>(obj: T, mode: "keys"): (keyof T)[];
function toArray<T extends object>(obj: T, mode: "values"): T[keyof T][];
function toArray<T extends object>(
	obj: T,
	mode: "entries",
): [keyof T, T[keyof T]][];

function toArray<T extends object>(
	obj: T,
	mode: "values" | "keys" | "entries" = "values",
) {
	switch (mode) {
		case "keys":
			return Object.keys(obj) as (keyof T)[];
		case "entries":
			return Object.entries(obj) as [keyof T, T[keyof T]][];
		default:
			return Object.values(obj) as T[keyof T][];
	}
}

const objectUtils = {
	toArray,
};

export { objectUtils };
